export class Theme {
    disclaimerContent: string;
    displayMap: boolean;
    logoUri: string;
    primaryColor: string;
    secondaryColor: string;
    textColor: string;
    filterConfiguration: { useLocationNameFilter: boolean };

    apply() {
      const themeStyleSheetName = 'instance-theme';
      const existingElement = document.getElementById(themeStyleSheetName);
      if (existingElement !== null) {
          existingElement.parentElement.removeChild(existingElement);
      }

      const themeStyleSheet = document.createElement('style');
      themeStyleSheet.setAttribute('id', themeStyleSheetName);
      const styleElem = document.head.appendChild(themeStyleSheet);

      styleElem.innerHTML = `
          /* Buttons */
          .btn.btn-primary {
              color: ${this.textColor} !important;
              background-color: ${this.primaryColor} !important;
              border-color: ${this.primaryColor} !important;
          }

          .btn.btn-outline {
              color: ${this.primaryColor} !important;
              border-color: ${this.primaryColor} !important;
          }
          .btn.btn-outline:hover {
              color: ${this.primaryColor} !important;
              border-color: rgba(${parseInt(this.primaryColor.substring(1, 3), 16)},
              ${parseInt(this.primaryColor.substring(3, 5), 16)}, ${parseInt(this.primaryColor.substring(5, 7), 16)}, .8) !important;
          }

          .btn.btn-apply {
              color: ${this.textColor} !important;
              background-color:  ${this.primaryColor} !important;
              border-color: ${this.primaryColor} !important;
          }
          .btn-apply:hover {
              background-color: rgba(${parseInt(this.primaryColor.substring(1, 3), 16)},
                  ${parseInt(this.primaryColor.substring(3, 5), 16)}, ${parseInt(this.primaryColor.substring(5, 7), 16)}, .8) !important;
          }
          .file-field .btn.btn-outline{
              color: ${this.primaryColor} !important;
              border: 1px solid ${this.primaryColor} !important;
          }

          .file-field .btn.btn-outline:hover{
              color: #fff !important;
              background-color: ${this.primaryColor} !important;
              border: 1px solid ${this.primaryColor} !important;
          }
            
          /* YBR
          .ybr.list-group li.active {
              background-color: rgba(${parseInt(this.primaryColor.substring(1, 3), 16)},
                  ${parseInt(this.primaryColor.substring(3, 5), 16)}, ${parseInt(this.primaryColor.substring(5, 7), 16)}, .05) !important;
              border-color: ${this.primaryColor} !important;
              color: ${this.primaryColor} !important;
          }*/
          .ybr.list-group li::before { border: solid 2px ${this.primaryColor} !important; }
          .ybr.list-group li.half::after { background-color: ${this.primaryColor} !important; }
          .ybr.list-group li.full::after { background-color: ${this.primaryColor} !important; }

          .filterToggle:hover{
              background-color: ${this.primaryColor} !important;
          }
          .menuToggle:hover{
              background-color: ${this.primaryColor} !important;
          }
      `;
    }
}
